import Vue from 'vue'
import Vuex from 'vuex'
import { getProfileAPI } from '../api/aq'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    PersonList:[], //数字人列表
    DraftList:[], //草稿列表
    ProductList:[], //作品列表
    SourceList:[], //资源列表
    FrontAssetList:[], //前景列表
    BgAssetList:[], //背景列表
    BgColorList:[], //背景颜色列表
    FilterList:[], //滤镜库列表
    personInfo:{},//数字人信息
  },
  getters: {
  },
  mutations: {
    // 设置数字人列表数据
    SetPersonList(state, data){
      state.PersonList = data
    },
    // 设置草稿列表数据
    SetDraftList(state, data){
      state.DraftList = data
    },
    // 设置作品列表数据
    SetProductList(state, data){
      state.ProductList = data
    },
    // 设置资源列表数据
    SetSourceList(state, data){
      state.SourceList = data
    },
    // 设置前景资源列表数据
    SetFrontAssetList(state, data){
      state.FrontAssetList = data
    },
    // 设置背景资源列表数据
    SetBgAssetList(state, data){
      state.BgAssetList = data
    },
    // 设置背景颜色列表数据
    SetBgColorList(state, data){
      state.BgColorList = data
    },
    // 设置滤镜库列表数据
    SetFilterList(state, data){
      state.FilterList = data
    },
    // 设置用户信息
    SetPersonInfo(state, data){
      state.personInfo = data
    }
  },
  actions: {
    // 获取用户信息
    async getUerInfo({commit}){
      const { data } = await getProfileAPI()
      if( data.code == 200 ){
          window.localStorage.setItem('adminFlag',data.data.adminFlag)
          window.localStorage.setItem('productFlag',data.data.productFlag)
          window.localStorage.setItem('interactFlag',data.data.interactFlag)
          window.localStorage.setItem('adminName',data.data.truename)
          window.localStorage.setItem('username',data.data.username)
          window.localStorage.setItem('avatar',data.data.avatar)
          commit('SetPersonInfo',data.data)
          // router.push({path:'/mine'})
          // router.push({path:'/intelligent'})
      }
      console.log('获取用户信息', data)
    }, 
  },
  modules: {
  }
})
